import React from 'react';

import './styles.scss';

const Checkbox = props => {
  const { inputName, onClick, checked } = props;
  return (
    <span className="customCheckbox">
      <input
        checked={checked}
        onClick={onClick}
        onChange={() => {}}
        type="checkbox"
        name={inputName}
      />
      <span className="box">
        <span className="check" />
      </span>
    </span>
  );
};

export default Checkbox;
